import { render, staticRenderFns } from "./CollegeManage.vue?vue&type=template&id=1c269906&scoped=true"
import script from "./CollegeManage.vue?vue&type=script&lang=js"
export * from "./CollegeManage.vue?vue&type=script&lang=js"
import style0 from "./CollegeManage.vue?vue&type=style&index=0&id=1c269906&prod&scoped=true&lang=css"
import style1 from "./CollegeManage.vue?vue&type=style&index=1&id=1c269906&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c269906",
  null
  
)

export default component.exports